import { Button, Grid } from '@mui/material';
import React, { FC } from 'react';
import {
  ITreatmentOfChronicAcromegallyPegvisomant,
  ITreatmentOfChronicAcromegallyPegvisomantProps
} from './TreatmentOfChronicAcromegallyPegvisomant.types';
import { Input } from '../../../../../../../shared/ui/form/input/Input';
import { GenericIcon } from '../../../../../../../shared/genericIcon/GenericIcon';
import { themeMUI } from '../../../../../../../../theme/theme';
import { SelectCustom } from '../../../../../../../shared/ui/form/select/Select';
import { pegvisomantDoseOptions } from '../ThirdStage.helper';
import { DateInput } from '../../../../../../../shared/ui/form/date/Date';
import { useArraySection } from '../../../../useArraySection';
import { initialTreatmentOfChronicAcromegallyPegvisomant } from './TreatmentOfChronicAcromegallyPegvisomant.helper';
import { useErrorEndDate } from '../../useErrorEndDate';

export const TreatmentOfChronicAcromegallyPegvisomant: FC<ITreatmentOfChronicAcromegallyPegvisomantProps> = ({
  id,
  initial,
  handleAddTreatmentOfChronicAcromegallyPegvisomant,
  editable,
  handleDeleteTreatmentOfChronicAcromegallyPegvisomant
}) => {
  const { formik, handleOnClick, disabledAdd } = useArraySection<ITreatmentOfChronicAcromegallyPegvisomant>(
    initial ?? initialTreatmentOfChronicAcromegallyPegvisomant,
    handleAddTreatmentOfChronicAcromegallyPegvisomant
  );

  const errorDate = useErrorEndDate(formik, formik.values.dateStart, formik.values.dateEnd);

  return (
    <>
      {!editable && (
        <Grid
          item
          xs={0.5}
          mt={1}
          mb={editable ? 0 : 1}
          display={'flex'}
          flexDirection={'column'}
          alignItems={'flex-start'}
          justifyContent={'center'}
        >
          {Number(id) + 1}.
        </Grid>
      )}
      <Grid item xs={2.75} pr={1} mt={1} mb={editable ? 0 : 1}>
        <SelectCustom
          disabled={!editable}
          name={'dose'}
          required={true}
          placeholder={'dawka (mg)'}
          label={'Dawka (mg)'}
          onChange={formik.handleChange}
          value={formik.values.dose}
          options={pegvisomantDoseOptions}
        />
      </Grid>
      <Grid item xs={2.75} pr={1} mt={1} mb={editable ? 0 : 1}>
        <Input
          InputLabelProps={{ shrink: true }}
          disabled={!editable}
          name={'frequency'}
          type={'text'}
          onChange={formik.handleChange}
          value={formik.values.frequency}
          placeholder={'częstotliwość (dni)'}
          label={'Częstotliwość (dni)'}
        />
      </Grid>
      <Grid item xs={2.75} pr={1} mt={1} mb={editable ? 0 : 1}>
        <DateInput
          disabled={!editable}
          label={'okres - OD'}
          required={true}
          views={['year', 'month']}
          openTo={'year'}
          name={'dateStart'}
          inputFormat={'mm.yyyy'}
          value={formik.values.dateStart}
          onBlur={() => formik.setFieldTouched('dateStart', true)}
          onChange={e => formik.setFieldValue('dateStart', e)}
        />
      </Grid>
      <Grid item xs={2.75} mt={1} mb={editable ? 0 : 1}>
        <DateInput
          disabled={!editable}
          label={'okres - DO'}
          isStill={true}
          required={true}
          views={['year', 'month']}
          openTo={'year'}
          name={'dateEnd'}
          error={errorDate}
          inputFormat={'mm.yyyy'}
          isActive={formik.values.dateEndIsActive}
          setIsActive={() => formik.setFieldValue('dateEndIsActive', !formik.values.dateEndIsActive)}
          value={formik.values.dateEnd}
          onBlur={() => formik.setFieldTouched('dateEnd', true)}
          onChange={e => formik.setFieldValue('dateEnd', e)}
        />
      </Grid>

      {handleDeleteTreatmentOfChronicAcromegallyPegvisomant && (
        <Grid item xs={0.5} pl={1} display={'flex'} justifyContent={'center'}>
          <div
            style={{ margin: 'auto' }}
            onClick={() => {
              if (typeof id === 'number') {
                handleDeleteTreatmentOfChronicAcromegallyPegvisomant(id);
              }
            }}
          >
            <GenericIcon
              iconName="Close"
              style={{
                color: themeMUI.palette.primary.main,
                cursor: 'pointer',
                verticalAlign: 'middle'
              }}
            />
          </div>
        </Grid>
      )}
      {handleAddTreatmentOfChronicAcromegallyPegvisomant && (
        <Grid item xs={1} pl={1} pt={1} display={'flex'} justifyContent={'center'}>
          <Button disabled={disabledAdd || errorDate} variant="contained" color={'primary'} onClick={handleOnClick}>
            ZAPISZ
          </Button>
        </Grid>
      )}
    </>
  );
};
